import { request } from '@/shared/api/request'

export const approveSelf = (externalId, person) => {
	return request({ url: `colcontract/tradeUnion/person/approveSelf/${externalId}`, method: 'POST', data: person })
}
